import script from "./ShowStatistics.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShowStatistics.vue?vue&type=script&lang=ts&setup=true"

import "./ShowStatistics.vue?vue&type=style&index=0&id=b015e0fe&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b015e0fe"]])

export default __exports__